export enum ReferralStatus {
    Undefined = 'Undefined', // Отсутствует
    NoAnswer = 'NoAnswer',
    ConversationHeld = 'ConversationHeld',
    CertificateReceived = 'CertificateReceived',
    NormalizedWithoutCertificate = 'NormalizedWithoutCertificate',
}

export const ReferralStatusUtil = {
    getStringValue: (status: ReferralStatus): string => {
        switch (status) {
            case ReferralStatus.Undefined:
                return 'Отсутствует';
            case ReferralStatus.NoAnswer:
                return 'Не отвечает';
            case ReferralStatus.ConversationHeld:
                return 'Проведена беседа';
            case ReferralStatus.CertificateReceived:
                return 'Получена справка';
            case ReferralStatus.NormalizedWithoutCertificate:
                return 'Нормализовалось давление/пульс без справки';
            default:
                return 'Не задан';
        }
    }
}

export interface DirectionsFilter {
    companyId?: number;
    fio?: string;
    fromDate: string | null; // ISO date string yyyy-MM-dd
    toDate: string | null;   // ISO date string yyyy-MM-dd
    statuses?: ReferralStatus[]; // enum names from backend
    page?: number;
    pageSize?: number;
}

export interface DirectionsDispatcherDto {
    id: number;
    lastName: string;
    firstName: string;
    middleName?: string | null;
}

export interface DirectionsDocumentDto {
    id: number;
    sendDate: string; // ISO
}

export interface DirectionsDriverDto {
    driverId: number;
    lastName: string;
    firstName: string;
    middleName?: string | null;
    companyId: number;
    companyName: string;
    referralStatus: ReferralStatus; // enum name
    referralCallDate?: string | null; // yyyy-MM-dd
    dispatchers: DirectionsDispatcherDto[];
    documents: DirectionsDocumentDto[];
}
